import React, { useState } from "react";
import ApiService from "../../services/apiService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const TicketResolveModal = ({ showModal, setShowModal, bookingId, ticketId, requestType }) => {
  const [comment, setComment] = useState("");
  const navigate = useNavigate();

  const updateTicketStatus = () => {
    if (!comment.trim()) {
      alert("Comment is required to resolve the ticket.");
      return;
    }

    ApiService.put(`booking/tickets/${ticketId}`, { status: "resolved", bookingId, type: requestType, resolveComment: comment }).then((result)=> {
      setShowModal(false);
      setComment("");
      toast.success("Ticket marked as resolved");
      navigate('/booking', { replace: true }); 
    }).catch((err)=> {
      console.log(err)
      setShowModal(false);
      setComment("");
      toast.error("somethign went wrong")
    })
    
  };

  return (
    <>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          {/* Modal Content */}
          <div className="bg-white w-1/3 p-6 rounded shadow-lg">
            <h4 className="text-lg font-semibold mb-4">Resolve Ticket</h4>
            <label className="mb-2 form-label">Please provide a reason for resolve ticket(remark):</label>
            <textarea
              className="w-full p-2 border border-gray-300 rounded mb-4"
              rows="4"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Enter your comment here..."
            />
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
              >
                Close
              </button>
              <button
                onClick={updateTicketStatus}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Resolved
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TicketResolveModal;
